import { AfterViewInit, Component, ElementRef, EventEmitter, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationItem } from '../navigation';
import { EbmsVeeyaaConfig } from '../../../../../app-config';
import { Location } from '@angular/common';

@Component({
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss']
})
export class NavContentComponent implements OnInit, AfterViewInit {
  public nextConfig: any;
  public navigation: any;
  public prevDisabled: string;
  public nextDisabled: string;
  public contentWidth: number;
  public wrapperWidth: any;
  public scrollWidth: any;
  public windowWidth: number;
  public isMobileView: boolean = false;

  @Output() onNavMobCollapse = new EventEmitter();
  
  // Mobile menu properties
  public isMobileMenuOpen: boolean = false;

  @ViewChild('navbarContent', {static: false}) navbarContent: ElementRef;
  @ViewChild('navbarWrapper', {static: false}) navbarWrapper: ElementRef;

  constructor(public nav: NavigationItem, private zone: NgZone, private location: Location) {
    this.nextConfig = EbmsVeeyaaConfig.config;
    this.windowWidth = window.innerWidth;
    this.checkMobileView();

    this.navigation = this.nav.get();
    this.prevDisabled = 'disabled';
    this.nextDisabled = '';
    this.scrollWidth = 0;
    this.contentWidth = 0;
  }

  ngOnInit() {
    if (this.windowWidth < 992) {
      this.nextConfig['layout'] = 'vertical';
      this.isMobileView = true;
      setTimeout(() => {
        const navbar = document.querySelector('.pcoded-navbar');
        const navPsNext = document.querySelector('#nav-ps-next') as HTMLElement;
        
        if (navbar) {
          navbar.classList.add('menupos-static');
        }
        if (navPsNext) {
          navPsNext.style.maxHeight = '100%';
        }
      }, 500);
    }
    
    // Listen for window resize to detect mobile/desktop changes
    window.addEventListener('resize', () => {
      this.checkMobileView();
    });

    // Listen for mobile menu state changes from the existing system
    this.setupMobileMenuListener();
  }

  ngAfterViewInit() {
    if (this.nextConfig['layout'] === 'horizontal') {
      this.contentWidth = this.navbarContent.nativeElement.clientWidth;
      this.wrapperWidth = this.navbarWrapper.nativeElement.clientWidth;
    }
  }

  scrollPlus() {
    this.scrollWidth = this.scrollWidth + (this.wrapperWidth - 80);
    if (this.scrollWidth > (this.contentWidth - this.wrapperWidth)) {
      this.scrollWidth = this.contentWidth - this.wrapperWidth + 80;
      this.nextDisabled = 'disabled';
    }
    this.prevDisabled = '';
    const sideNavHorizontal = document.querySelector('#side-nav-horizontal') as HTMLElement;
    if (sideNavHorizontal) {
      if(this.nextConfig.rtlLayout) {
        sideNavHorizontal.style.marginRight = '-' + this.scrollWidth + 'px';
      } else {
        sideNavHorizontal.style.marginLeft = '-' + this.scrollWidth + 'px';
      }
    }
  }

  scrollMinus() {
    this.scrollWidth = this.scrollWidth - this.wrapperWidth;
    if (this.scrollWidth < 0) {
      this.scrollWidth = 0;
      this.prevDisabled = 'disabled';
    }
    this.nextDisabled = '';
    const sideNavHorizontal = document.querySelector('#side-nav-horizontal') as HTMLElement;
    if (sideNavHorizontal) {
      if(this.nextConfig.rtlLayout) {
        sideNavHorizontal.style.marginRight = '-' + this.scrollWidth + 'px';
      } else {
        sideNavHorizontal.style.marginLeft = '-' + this.scrollWidth + 'px';
      }
    }

  }

  fireLeave() {
    const sections = document.querySelectorAll('.pcoded-hasmenu');
    for (let i = 0; i < sections.length; i++) {
      sections[i].classList.remove('active');
      sections[i].classList.remove('pcoded-trigger');
    }

    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        parent.classList.add('active');
      } else if(up_parent.classList.contains('pcoded-hasmenu')) {
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        last_parent.classList.add('active');
      }
    }
  }

  navMob() {
    const navElement = document.querySelector('app-navigation.pcoded-navbar');
    if (this.windowWidth < 992 && navElement && navElement.classList.contains('mob-open')) {
      this.onNavMobCollapse.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    if (this.location['_baseHref']) {
      current_url = this.location['_baseHref'] + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent.parentElement.parentElement;
      const last_parent = up_parent.parentElement;
      if (parent.classList.contains('pcoded-hasmenu')) {
        if (this.nextConfig['layout'] === 'vertical') {
          parent.classList.add('pcoded-trigger');
        }
        parent.classList.add('active');
      } else if(up_parent.classList.contains('pcoded-hasmenu')) {
        if (this.nextConfig['layout'] === 'vertical') {
          up_parent.classList.add('pcoded-trigger');
        }
        up_parent.classList.add('active');
      } else if (last_parent.classList.contains('pcoded-hasmenu')) {
        if (this.nextConfig['layout'] === 'vertical') {
          last_parent.classList.add('pcoded-trigger');
        }
        last_parent.classList.add('active');
      }
    }
  }

  checkMobileView() {
    this.windowWidth = window.innerWidth;
    this.isMobileView = this.windowWidth < 992;
  }

  onMobileItemClick(item: any) {
    // Handle mobile menu item clicks
    console.log('Mobile item clicked:', item);
  }

  setupMobileMenuListener() {
    // Listen for changes to the existing mobile menu system
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target as HTMLElement;
          const isOpen = target.classList.contains('mob-open');
          console.log('Mobile menu state changed:', isOpen);
          
          if (isOpen !== this.isMobileMenuOpen) {
            this.isMobileMenuOpen = isOpen;
            if (isOpen) {
              document.body.classList.add('mobile-menu-open');
            } else {
              document.body.classList.remove('mobile-menu-open');
            }
            console.log('Mobile menu state synced:', this.isMobileMenuOpen);
          }
        }
      });
    });

    // Observe the navigation element for class changes
    const navElement = document.querySelector('app-navigation.pcoded-navbar');
    if (navElement) {
      observer.observe(navElement, { attributes: true, attributeFilter: ['class'] });
      console.log('Mobile menu observer setup complete');
    } else {
      console.log('Navigation element not found for observer');
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    console.log('Mobile menu toggled, isOpen:', this.isMobileMenuOpen);
    
    // Sync with existing mobile menu system
    const navElement = document.querySelector('app-navigation.pcoded-navbar');
    if (navElement) {
    if (this.isMobileMenuOpen) {
        navElement.classList.add('mob-open');
      document.body.classList.add('mobile-menu-open');
        console.log('Mobile menu opened');
    } else {
        navElement.classList.remove('mob-open');
      document.body.classList.remove('mobile-menu-open');
        console.log('Mobile menu closed');
      }
    }
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    document.body.classList.remove('mobile-menu-open');
    
    // Sync with existing mobile menu system
    const navElement = document.querySelector('app-navigation.pcoded-navbar');
    if (navElement) {
      navElement.classList.remove('mob-open');
    }
  }

  isNavOpen(): boolean {
    const navElement = document.querySelector('app-navigation.pcoded-navbar');
    return navElement ? navElement.classList.contains('mob-open') : false;
  }

  // Fallback mobile navigation methods
  public openSubmenus: Set<string> = new Set();

  toggleMobileSubmenu(itemId: string) {
    if (this.openSubmenus.has(itemId)) {
      this.openSubmenus.delete(itemId);
    } else {
      this.openSubmenus.add(itemId);
    }
  }

  isSubmenuOpen(itemId: string): boolean {
    return this.openSubmenus.has(itemId);
  }

}
